import { render, staticRenderFns } from "./StatisticDashboard.vue?vue&type=template&id=af7b6d4e&scoped=true&"
import script from "./StatisticDashboard.vue?vue&type=script&lang=js&"
export * from "./StatisticDashboard.vue?vue&type=script&lang=js&"
import style0 from "./StatisticDashboard.vue?vue&type=style&index=0&id=af7b6d4e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "af7b6d4e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAlert } from 'vuetify/lib/components/VAlert';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
import { VTab } from 'vuetify/lib/components/VTabs';
import { VTabItem } from 'vuetify/lib/components/VTabs';
import { VTabs } from 'vuetify/lib/components/VTabs';
import { VTabsItems } from 'vuetify/lib/components/VTabs';
installComponents(component, {VAlert,VCard,VCardText,VDivider,VIcon,VProgressCircular,VTab,VTabItem,VTabs,VTabsItems})
